function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "supervisor_account-black-18dp",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M15,10.5H6.75V8.813c0-1.354,2.685-2.063,4.125-2.063S15,7.458,15,8.813V10.5Zm-9.751,0H0V8.625C0,6.9,3.418,6,5.25,6a9.222,9.222,0,0,1,1.778.21,2.966,2.966,0,0,0-1.778,2.6V10.5ZM10.875,5.25a1.875,1.875,0,1,1,1.868-1.875A1.877,1.877,0,0,1,10.875,5.25ZM5.25,4.5A2.25,2.25,0,1,1,7.492,2.25,2.253,2.253,0,0,1,5.25,4.5Z",
  fill: "#878787"
}));

var SvgIconUsers = function SvgIconUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Group",
    "data-name": "Icon Group",
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-users.d4af2e40.svg";
export { ForwardRef as ReactComponent };